import { Camera } from '@babylonjs/core/Cameras/camera';
import { Token } from '@models/classes/token';
import { ViewpointNode } from '@models/classes/viewpoints/viewpoint-node';
import { ITrackedClass } from '@models/interfaces';
import { Renderer } from './renderer';

export class ViewpointRenderer extends Renderer<ViewpointNode, Camera> {
    modelToken = Token.ViewpointNode;
    update3dInternal(node: ITrackedClass<ViewpointNode>) {}
}
